import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import PopModal from '../../../Constant/Custom/Models/PopModal';
import { serverUrl } from '../../../Constant/Static/config';
import { AuthContext } from '../../../Auth/AuthContext';
import Loader from '../../../Constant/Custom/Loader';

function SpecialReserve({ handlePrevious, handleNext }) {

    const { auth } = useContext(AuthContext);

    const [loading, setLoading] = useState(true);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalType, setModalType] = useState({ title: '', text: '', icon: '' });
    const [onConfirm, setOnConfirm] = useState(() => () => { });

    const [csrfToken, setCsrfToken] = useState('');
    // const [errors, setErrors] = useState({});

    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);

    const [specialForm, setSpecialForm] = useState({
        disability: '',
        sports: '',
        sportsLvl: 0,
        freedomFighter: '',
        exService: '',
        srilankanRefugee: '',
        firstGraduate: ''
    });

    const setDefaultForm = () => {
        setSpecialForm({
            disability: '',
            sports: '',
            sportsLvl: 0,
            freedomFighter: '',
            exService: '',
            srilankanRefugee: '',
            firstGraduate: ''
        })
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setSpecialForm((prevState) => ({
            ...prevState,
            [name]: value,
            ...(name === "sports" && value === "N" && { sportsLvl: 0 }),
        }));
    };

    const validateForm = () => {
        const requiredFields = Object.keys(specialForm);
        const errors = [];

        requiredFields.forEach((field) => {
            if (field !== 'appNo' && field !== 'appName' && field !== 'email' && field !== 'phone' && field !== 'sportsLvl')
                if (specialForm[field] !== 'Y' && specialForm[field] !== 'N') {
                    errors.push(`${field.charAt(0).toUpperCase() + field.slice(1)} must be 'Y' or 'N'.`);
                }
        });

        if (specialForm.sports === "Y" && (specialForm.sportsLvl === 0 || specialForm.sportsLvl === "0")) {
            errors.push("Please select the participation level");
        }

        if (errors.length > 0) {
            // console.log(errors);
            return false;
        }

        return true;
    };

    const handleSpecialDetailSubmit = async () => {

        const userDataFromLocalStorage = auth.user;

        if (!validateForm()) {
            setModalType({
                icon: 'warning',
                title: 'Warning',
                text: 'Please Fill All the Required Details',
            });
            openModal();
            setOnConfirm(() => closeModal);
            // console.log('Form is not valid');
            return;
        } else if (userDataFromLocalStorage) {
            try {
                setLoading(true)
                const response = await axios.post(`${serverUrl}/api/user/SpecialReserve`, {
                    appno: userDataFromLocalStorage.appno,
                    userName: userDataFromLocalStorage.userName,
                    email: userDataFromLocalStorage.email,
                    mobile: userDataFromLocalStorage.mobile,
                    specialForm
                }, {
                    headers: {
                        'CSRF-Token': csrfToken
                    },
                    withCredentials: true
                });
                if (response.status === 200) {
                    setModalType({
                        icon: 'success',
                        title: 'Success',
                        text: 'Special Reservation Details are saved.',
                    });
                    openModal();
                    setOnConfirm(() => handleNext);
                } else {
                    // console.log(response);
                }
            } catch (err) {
                console.error('Failed to store data', err);
            }
            finally {
                setLoading(false);
            }
        }
    };

    useEffect(() => {
        const fetchCsrfToken = async () => {
            try {
                const response = await axios.get(`${serverUrl}/api/csrf-token`, {
                    withCredentials: true  // Ensure cookies are sent
                });
                setCsrfToken(response.data.csrfToken);  // Set CSRF token
            } catch (error) {
                console.error('Error fetching CSRF token:', error);
            }
        };

        fetchCsrfToken();
    }, []);

    useEffect(() => {
        const fetchUserData = async () => {
            localStorage.setItem('currentSection', 4);
            if (csrfToken) {
                try {
                    setLoading(true);
                    const userDataFromLocalStorage = auth.user;
                    if (userDataFromLocalStorage) {
                        const response = await axios.post(
                            `${serverUrl}/api/user/loadSpecialReserve`,
                            {
                                appno: userDataFromLocalStorage.appno,
                                userName: userDataFromLocalStorage.userName,
                                email: userDataFromLocalStorage.email,
                                mobile: userDataFromLocalStorage.mobile
                            },
                            {
                                headers: {
                                    'CSRF-Token': csrfToken
                                },
                                withCredentials: true
                            }
                        );
                        if (response.data.disability === "") {
                            setDefaultForm();
                        } else {
                            setSpecialForm(response.data);
                        }
                    }
                } catch (error) {
                    console.error('Error fetching user data:', error);
                } finally {
                    setLoading(false);
                }
            }
        };

        fetchUserData();
    }, [csrfToken]);

    if (loading) {
        return <Loader />;
    }

    return (
        <section>
            <div className='section-head-container'>
                <h2 className='section-title'>Special Reservation Details </h2>
                {/* <button className='log-btn button-primary' onClick={handleNext}>Save & Next</button> */}
            </div>
            <div>
                <div className='special-container'>
                    <div className='special-item'>
                        <h5>Differently Abled Person:<br />
                            <span>&ensp;மாற்றுத்திறனாளி</span>
                        </h5>
                    </div>
                    <div className='special-item'>
                        <label className="radio-container">
                            <input
                                type="radio"
                                name="disability"
                                value="Y"
                                checked={specialForm.disability === 'Y'}
                                onChange={handleChange} />
                            <span>Yes</span>
                        </label>
                        <label className="radio-container">
                            <input
                                type="radio"
                                name="disability"
                                value="N"
                                checked={specialForm.disability === 'N'}
                                onChange={handleChange} />
                            <span>No</span>
                        </label>
                    </div>
                </div>
                <div className='special-container'>
                    <div className='special-item'>
                        <h5>Eminent Sports Person:<br />
                            <span>&ensp;சிறந்த விளையாட்டு நபர்</span>
                        </h5>
                    </div>
                    <div className='special-item'>
                        <label className="radio-container">
                            <input type="radio" name="sports" value="Y"
                                checked={specialForm.sports === 'Y'}
                                onChange={handleChange} /><span>Yes</span>
                        </label>
                        <label className="radio-container">
                            <input type="radio" name="sports" value="N"
                                checked={specialForm.sports === 'N'}
                                onChange={handleChange} /><span>No</span>
                        </label>
                    </div>
                </div>
                {specialForm.sports === 'Y' ? (
                    <div className='special-container'>
                        <div className='special-item'>
                            <h5>Level of Participation :<br />
                                <span>&ensp;பங்கேற்பின் அளவு</span>
                            </h5>
                        </div>
                        <div className='special-item'>
                            <select
                                name='sportsLvl'
                                value={specialForm.sports === 'Y' ? specialForm.sportsLvl : 0}
                                onChange={handleChange}
                                required
                            >
                                <option value="0" selected="selected">--Select--</option>
                                <option value="1" >International Level</option>
                                <option value="2">National Level</option>
                                <option value="3">State Level</option>
                                <option value="4">Divisional Level</option>
                            </select>
                        </div>
                    </div>
                ) : null}
                <div className='special-container'>
                    <div className='special-item'>
                        <h5>Children of Freedom Fighter:<br />
                            <span>&ensp;விடுதலைப் போராட்ட வீரரின் வாரிசு</span>
                        </h5>
                    </div>
                    <div className='special-item'>
                        <label className="radio-container">
                            <input type="radio" name="freedomFighter" value="Y"
                                checked={specialForm.freedomFighter === 'Y'}
                                onChange={handleChange} /><span>Yes</span>
                        </label>
                        <label className="radio-container">
                            <input type="radio" name="freedomFighter" value="N"
                                checked={specialForm.freedomFighter === 'N'}
                                onChange={handleChange} /><span>No</span>
                        </label>
                    </div>
                </div>
                <div className='special-container'>
                    <div className='special-item'>
                        <h5>Children of Ex-service man:<br />
                            <span>&ensp;முன்னாள் இராணுவ வீரரின்  வாரிசு</span>
                        </h5>
                    </div>
                    <div className='special-item'>
                        <label className="radio-container">
                            <input type="radio" name="exService" value="Y"
                                checked={specialForm.exService === 'Y'}
                                onChange={handleChange} /><span>Yes</span>
                        </label>
                        <label className="radio-container">
                            <input type="radio" name="exService" value="N"
                                checked={specialForm.exService === 'N'}
                                onChange={handleChange} /><span>No</span>
                        </label>
                    </div>
                </div>
                <div className='special-container'>
                    <div className='special-item'>
                        <h5>Srilankan Tamil Refugee:<br />
                            <span>&ensp;இலங்கைத் தமிழ் அகதிகள்</span>
                        </h5>
                    </div>
                    <div className='special-item'>
                        <label className="radio-container">
                            <input type="radio" name="srilankanRefugee" value="Y"
                                checked={specialForm.srilankanRefugee === 'Y'}
                                onChange={handleChange} /><span>Yes</span>
                        </label>
                        <label className="radio-container">
                            <input type="radio" name="srilankanRefugee" value="N"
                                checked={specialForm.srilankanRefugee === 'N'}
                                onChange={handleChange} /><span>No</span>
                        </label>
                    </div>
                </div>
                <h4 className='section-title'>Scholarship Details</h4>
                <div className='special-container'>
                    <div className='special-item'>
                        <h5>First Graduate:<br />
                            <span>&ensp;முதல் பட்டதாரி</span>
                        </h5>
                    </div>
                    <div className='special-item'>
                        <label className="radio-container">
                            <input type="radio" name="firstGraduate" value="Y"
                                checked={specialForm.firstGraduate === 'Y'}
                                onChange={handleChange} /><span>Yes</span>
                        </label>
                        <label className="radio-container">
                            <input type="radio" name="firstGraduate" value="N"
                                checked={specialForm.firstGraduate === 'N'}
                                onChange={handleChange} /><span>No</span>
                        </label>
                    </div>
                </div>
            </div>
            <br />
            <div className='next-button'>
                <button className='log-btn button-secondary' onClick={handlePrevious}>Previous</button>
                <button className='log-btn button-primary' onClick={handleSpecialDetailSubmit}>Save & Next</button>
            </div>
            <div style={{ position: 'relative', alignSelf: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <PopModal
                    isOpen={isModalOpen}
                    type={modalType}
                    confirmButtonText="OK"
                    onConfirm={onConfirm}
                />
            </div>
        </section>
    )
}

export default SpecialReserve;